import React, {useEffect} from 'react';
import {Modal, Form, Button, Row, Col, Input, Select, DatePicker, InputNumber} from 'antd';
import dayjs from 'dayjs';

const {RangePicker} = DatePicker;

interface WorkHistoryModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: (values: any) => void;
  initialValues?: any;
  confirmLoading?: boolean;
}

const WorkHistoryModal: React.FC<WorkHistoryModalProps> = ({visible, onCancel, onOk, initialValues, confirmLoading}) => {
  const [form] = Form.useForm();
  const isEdit = !!initialValues;

  useEffect(() => {
    if (visible) {
      if (initialValues) {
        // 将 operatedEnv 字符串转为数组用于显示
        const formValues = {
          ...initialValues,
          operatedEnv: initialValues.operatedEnv ? initialValues.operatedEnv.split(',') : []
        };
        form.setFieldsValue(formValues);
      } else {
        form.resetFields();
      }
    }
  }, [visible, initialValues, form]);

  const handleOk = () => {
    form.validateFields().then(values => {
      // 将 operatedEnv 数组转为逗号分隔的字符串
      const submitValues = {
        ...values,
        operatedEnv: values.operatedEnv && values.operatedEnv.length > 0 ? values.operatedEnv.join(',') : ''
      };
      onOk(submitValues);
    });
  };

  return (
    <Modal
      title={isEdit ? '编辑工作履历' : '新增工作履历'}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      width={1000}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item name="workTime" label="工作时间" rules={[{required: true}]}>
              <Input placeholder="例如：2020-01至2023-12"/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="compName" label="公司名称" rules={[{required: true}]}>
              <Input/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="workType" label="工作类型">
              <Select options={[{value: '长期', label: '长期'}, {value: '临时', label: '临时'}]}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="workCnt" label="工作内容">
              <Select options={[{value: '长途运输', label: '长途运输'}, {value: '短途运输', label: '短途运输'}]}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="fuelTp" label="燃油类型">
              <Select options={[{value: '汽油', label: '汽油'}, {value: '柴油', label: '柴油'}]}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="accidentStat" label="出险情况">
              <Input/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="safetyRateStat" label="安全评级情况">
              <Select options={[{value: '优秀', label: '优秀'}, {value: '良', label: '良'}, {
                value: '中',
                label: '中'
              }, {value: '差', label: '差'}]}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="dailyAvgDriveHr" label="日均驾驶时长">
              <InputNumber addonAfter="小时" style={{width: '100%'}}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="dailyAvgDriveMile" label="日均驾驶里程">
              <InputNumber addonAfter="公里" style={{width: '100%'}}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="nightDriveRatio" label="夜间驾驶比例">
              <InputNumber addonAfter="%" style={{width: '100%'}}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="abnormalDriveDailyCnt" label="异常驾驶行为日均次数">
              <InputNumber addonAfter="次" style={{width: '100%'}}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="inattentiveDriveDailyCnt" label="驾驶不专注日均次数">
              <InputNumber addonAfter="次" style={{width: '100%'}}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="smokingDailyTrig" label="抽烟日均触发次数">
              <InputNumber addonAfter="次" style={{width: '100%'}}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="opCity" label="作业城市">
              <Input/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="opRoad" label="作业道路">
              <Select options={[
                {value: '高速公路', label: '高速公路'},
                {value: '一级公路', label: '一级公路'},
                {value: '二级公路', label: '二级公路'},
                {value: '三级公路', label: '三级公路'},
                {value: '四级公路', label: '四级公路'},
              ]}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="operatedEnv" label="作业过的环境">
              <Select mode="multiple" allowClear options={[
                {value: '雨天', label: '雨天'},
                {value: '雪天', label: '雪天'},
                {value: '酷暑', label: '酷暑'},
              ]}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="opSpeed" label="作业速度">
              <InputNumber addonAfter="km/h" style={{width: '100%'}}/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default WorkHistoryModal;

